import React, { Component } from 'react';
import {
    Box,
    Typography,
    Paper,
    Switch,
    Grid,
    Card,
    CardContent,
    Radio,
    Divider, // Adicionado o Divider que estava faltando
    Button
} from '@mui/material';

// Ícones do MUI
import ShoppingBagIcon from '@mui/icons-material/ShoppingBag';
import VisibilityIcon from '@mui/icons-material/Visibility';
import SendIcon from '@mui/icons-material/Send';
import DescriptionIcon from '@mui/icons-material/Description';
import SettingsIcon from '@mui/icons-material/Settings';
import InventoryIcon from '@mui/icons-material/Inventory2';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import { toast } from 'react-toastify';
// Estilo reaproveitável para os Switches roxos (Definido fora da classe)
const purpleSwitchSx = {
    '& .MuiSwitch-switchBase.Mui-checked': { color: '#9061f9' },
    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { bgcolor: '#9061f9' }
};

class SecaoPedidos extends Component {
    constructor(props) {
        super(props);
        this.state = {
            permitirPedidos: false,
            modoFinalizacao: '',
            confirmarAutomatico: false,
            exigirEndereco: false,
            exigirTelefone: false,
            permitirObservacoes: false,
            darBaixaAutomatica: false,
            exibirEsgotados: false
        };
    }

    componentDidMount() {
        if (this.props.data) {
            var { permitirPedidos, modoFinalizacao, confirmarAutomatico, exigirEndereco, exigirTelefone, permitirObservacoes, darBaixaAutomatica, exibirEsgotados } = this.props.data;

            this.setState({
                permitirPedidos,
                modoFinalizacao,
                confirmarAutomatico,
                exigirEndereco,
                exigirTelefone,
                permitirObservacoes,
                darBaixaAutomatica,
                exibirEsgotados
            });
        }
    }

    // Manipulador genérico corrigido para atualizar booleanos no State usando a chave
    handleToggleChange = (key) => (event) => {
        this.setState({ [key]: event.target.checked });
    };

    handleModoChange = (value) => {
        this.setState({ modoFinalizacao: value });
    };

    render() {
        const {
            permitirPedidos,
            modoFinalizacao,
            confirmarAutomatico,
            exigirEndereco,
            exigirTelefone,
            permitirObservacoes,
            darBaixaAutomatica,
            exibirEsgotados
        } = this.state;

        return (
            <Box sx={{ p: 0, bgcolor: '#ffffff', minHeight: '100vh', fontFamily: 'sans-serif' }}>

                {/* Título Principal da Seção */}
                <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#1a202c', mb: 0.5 }}>
                    Pedidos
                </Typography>
                <Typography variant="body2" color="textSecondary" sx={{ mb: 4 }}>
                    Carrinho e modo de finalização
                </Typography>

                {/* Subtítulo: Carrinho no Catálogo */}
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                    <ShoppingBagIcon fontSize="small" sx={{ color: '#9061f9' }} />
                    <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: '#1a202c' }}>
                        Carrinho no Catálogo
                    </Typography>
                </Box>

                {/* Container do Switch (Permitir pedidos) */}
                <Paper
                    variant="outlined"
                    sx={{
                        p: 2.5,
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        borderRadius: '12px',
                        borderColor: '#e2e8f0',
                        mb: 5
                    }}
                >
                    <Box>
                        <Typography variant="subtitle1" sx={{ fontWeight: '600', color: '#1a202c' }}>
                            Permitir pedidos pelo catálogo
                        </Typography>
                        <Typography variant="body2" color="textSecondary">
                            Quando ativo, clientes podem adicionar itens ao carrinho e finalizar pedidos.
                        </Typography>
                    </Box>

                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Typography
                            variant="body2"
                            sx={{ color: permitirPedidos ? '#9061f9' : '#718096', fontWeight: '500' }}
                        >
                            {permitirPedidos ? 'Ativo' : 'Inativo'}
                        </Typography>
                        <Switch
                            checked={permitirPedidos}
                            onChange={this.handleToggleChange('permitirPedidos')}
                            sx={purpleSwitchSx}
                        />
                    </Box>
                </Paper>

                {/* Subtítulo: Modo de Finalização */}
                <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: '#1a202c', mb: 0.5 }}>
                    Modo de Finalização
                </Typography>
                <Typography variant="body2" color="textSecondary" sx={{ mb: 3 }}>
                    Escolha como os clientes finalizam pedidos no catálogo público.
                </Typography>

                <Grid container spacing={3} size={{ xs: 12, }} sx={{ mb: 3 }}>


                    {/* Card 1: Somente Exibição */}

                    <Grid item size={{ xs: 12, md: 4 }}>

                        <Card

                            variant="outlined"

                            onClick={() => this.handleModoChange('exibicao')}

                            sx={{

                                cursor: 'pointer',

                                borderRadius: '12px',

                                borderColor: modoFinalizacao === 'exibicao' ? '#9061f9' : '#e2e8f0',

                                borderWidth: modoFinalizacao === 'exibicao' ? '2px' : '1px',

                                height: '100%',

                                transition: 'all 0.2s ease-in-out'

                            }}

                        >

                            <CardContent>

                                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 2 }}>

                                    <Box sx={{ p: 1, bgcolor: '#f1f5f9', borderRadius: '8px', display: 'flex' }}>

                                        <VisibilityIcon sx={{ color: '#64748b' }} />

                                    </Box>

                                    <Radio

                                        checked={modoFinalizacao === 'exibicao'}

                                        value="exibicao"

                                        sx={{ p: 0, color: '#cbd5e1', '&.Mui-checked': { color: '#9061f9' } }}

                                    />

                                </Box>

                                <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1, color: '#1a202c' }}>

                                    Somente exibição

                                </Typography>

                                <Typography variant="body2" color="textSecondary">

                                    Catálogo vira vitrine. Clientes visualizam detalhes sem enviar pedidos.

                                </Typography>

                            </CardContent>

                        </Card>

                    </Grid>


                    {/* Card 2: Finalizar pelo WhatsApp */}

                    <Grid item size={{ xs: 12, md: 4 }}>

                        <Card

                            variant="outlined"

                            onClick={() => this.handleModoChange('whatsapp')}

                            sx={{

                                cursor: 'pointer',

                                borderRadius: '12px',

                                borderColor: modoFinalizacao === 'whatsapp' ? '#9061f9' : '#e2e8f0',

                                borderWidth: modoFinalizacao === 'whatsapp' ? '2px' : '1px',

                                height: '100%',

                                transition: 'all 0.2s ease-in-out'

                            }}

                        >

                            <CardContent>

                                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 2 }}>

                                    <Box sx={{ p: 1, bgcolor: '#f1f5f9', borderRadius: '8px', display: 'flex' }}>

                                        <SendIcon sx={{ color: '#64748b', transform: 'rotate(-30deg)' }} />

                                    </Box>

                                    <Radio

                                        checked={modoFinalizacao === 'whatsapp'}

                                        value="whatsapp"

                                        sx={{ p: 0, color: '#cbd5e1', '&.Mui-checked': { color: '#9061f9' } }}

                                    />

                                </Box>

                                <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1, color: '#1a202c' }}>

                                    Finalizar pelo WhatsApp

                                </Typography>

                                <Typography variant="body2" color="textSecondary">

                                    Cliente envia carrinho para o WhatsApp com mensagem automática.

                                </Typography>

                            </CardContent>

                        </Card>

                    </Grid>


                    {/* Card 3: Registrar no fazpedido */}

                    <Grid item size={{ xs: 12, md: 4 }}>

                        <Card

                            variant="outlined"

                            onClick={() => this.handleModoChange('fazpedido')}

                            sx={{

                                cursor: 'pointer',

                                borderRadius: '12px',

                                borderColor: modoFinalizacao === 'fazpedido' ? '#9061f9' : '#e2e8f0',

                                borderWidth: modoFinalizacao === 'fazpedido' ? '2px' : '1px',

                                bgcolor: modoFinalizacao === 'fazpedido' ? '#fbfaff' : 'inherit',

                                height: '100%',

                                transition: 'all 0.2s ease-in-out'

                            }}

                        >

                            <CardContent>

                                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 2 }}>

                                    <Box sx={{ p: 1, bgcolor: '#f3e8ff', borderRadius: '8px', display: 'flex' }}>

                                        <DescriptionIcon sx={{ color: '#9061f9' }} />

                                    </Box>

                                    <Radio

                                        checked={modoFinalizacao === 'fazpedido'}

                                        value="fazpedido"

                                        sx={{ p: 0, color: '#cbd5e1', '&.Mui-checked': { color: '#9061f9' } }}

                                    />

                                </Box>

                                <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1, color: '#1a202c' }}>

                                    Registrar pedidos no fazpedido

                                </Typography>

                                <Typography variant="body2" color="textSecondary">

                                    Cliente finaliza no catálogo e você acompanha no painel.

                                </Typography>

                            </CardContent>

                        </Card>

                    </Grid>


                </Grid>

                {/* Subtítulo: Configurações de Pedido */}
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                    <SettingsIcon fontSize="small" sx={{ color: '#64748b' }} />
                    <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: '#1a202c' }}>
                        Configurações de Pedido
                    </Typography>
                </Box>

                <Paper
                    variant="outlined"
                    sx={{
                        borderRadius: '12px',
                        borderColor: '#e2e8f0',
                        overflow: 'hidden',
                        mb: 5
                    }}
                >
                    {/* Item 1: Confirmar pedidos automaticamente */}
                    <Box sx={{ p: 2.5, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Box>
                            <Typography variant="subtitle2" sx={{ fontWeight: '600', color: '#1a202c' }}>
                                Confirmar pedidos automaticamente
                            </Typography>
                            <Typography variant="body2" color="textSecondary">
                                Pedidos são confirmados sem necessidade de ação manual
                            </Typography>
                        </Box>
                        <Switch
                            checked={confirmarAutomatico}
                            onChange={this.handleToggleChange('confirmarAutomatico')}
                            sx={purpleSwitchSx}
                        />
                    </Box>
                    <Divider sx={{ borderColor: '#edf2f7' }} />

                    {/* Item 2: Exigir endereço */}
                    <Box sx={{ p: 2.5, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Box>
                            <Typography variant="subtitle2" sx={{ fontWeight: '600', color: '#1a202c' }}>
                                Exigir endereço
                            </Typography>
                            <Typography variant="body2" color="textSecondary">
                                Clientes devem informar endereço ao fazer pedido
                            </Typography>
                        </Box>
                        <Switch
                            checked={exigirEndereco}
                            onChange={this.handleToggleChange('exigirEndereco')}
                            sx={purpleSwitchSx}
                        />
                    </Box>
                    <Divider sx={{ borderColor: '#edf2f7' }} />

                    {/* Item 3: Exigir telefone */}
                    <Box sx={{ p: 2.5, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Box>
                            <Typography variant="subtitle2" sx={{ fontWeight: '600', color: '#1a202c' }}>
                                Exigir telefone
                            </Typography>
                            <Typography variant="body2" color="textSecondary">
                                Clientes devem informar telefone ao fazer pedido
                            </Typography>
                        </Box>
                        <Switch
                            checked={exigirTelefone}
                            onChange={this.handleToggleChange('exigirTelefone')}
                            sx={purpleSwitchSx}
                        />
                    </Box>
                    <Divider sx={{ borderColor: '#edf2f7' }} />

                    {/* Item 4: Permitir observações */}
                    <Box sx={{ p: 2.5, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Box>
                            <Typography variant="subtitle2" sx={{ fontWeight: '600', color: '#1a202c' }}>
                                Permitir observações
                            </Typography>
                            <Typography variant="body2" color="textSecondary">
                                Clientes podem adicionar notas ao pedido
                            </Typography>
                        </Box>
                        <Switch
                            checked={permitirObservacoes}
                            onChange={this.handleToggleChange('permitirObservacoes')}
                            sx={purpleSwitchSx}
                        />
                    </Box>
                </Paper>

                {/* ================= SEÇÃO: EXPERIÊNCIA DE ESTOQUE ================= */}
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
                    <InventoryIcon fontSize="small" sx={{ color: '#64748b' }} />
                    <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: '#1a202c' }}>
                        Experiência de Estoque
                    </Typography>
                </Box>
                <Typography variant="body2" color="textSecondary" sx={{ mb: 3 }}>
                    Defina como o catálogo reage a cada pedido e mantenha clientes informados sobre itens esgotados.
                </Typography>

                {/* Card Estoque 1: Dar baixa automática */}
                <Paper
                    variant="outlined"
                    sx={{
                        p: 2.5,
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        borderRadius: '12px',
                        borderColor: '#e2e8f0',
                        mb: 3
                    }}
                >
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                        <Box sx={{ p: 1, bgcolor: '#f3e8ff', borderRadius: '8px', display: 'flex' }}>
                            <AutoFixHighIcon sx={{ color: '#9061f9' }} />
                        </Box>
                        <Box>
                            <Typography variant="subtitle2" sx={{ fontWeight: '700', color: '#1a202c' }}>
                                Dar baixa automática no estoque
                            </Typography>
                            <Typography variant="body2" color="textSecondary">
                                Quando um pedido for aprovado, diminuímos automaticamente a quantidade disponível.
                            </Typography>
                        </Box>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                        <Typography variant="body2" sx={{ color: darBaixaAutomatica ? '#9061f9' : '#718096', fontWeight: '500' }}>
                            {darBaixaAutomatica ? 'Ativo' : 'Inativo'}
                        </Typography>
                        <Switch
                            checked={darBaixaAutomatica}
                            onChange={this.handleToggleChange('darBaixaAutomatica')}
                            sx={purpleSwitchSx}
                        />
                    </Box>
                </Paper>

                {/* Card Estoque 2: Exibir produtos esgotados */}
                <Paper
                    variant="outlined"
                    sx={{
                        p: 2.5,
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        borderRadius: '12px',
                        borderColor: '#e2e8f0'
                    }}
                >
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                        <Box sx={{ p: 1, bgcolor: '#f3e8ff', borderRadius: '8px', display: 'flex' }}>
                            <VisibilityIcon sx={{ color: '#9061f9' }} />
                        </Box>
                        <Box>
                            <Typography variant="subtitle2" sx={{ fontWeight: '700', color: '#1a202c' }}>
                                Exibir produtos esgotados
                            </Typography>
                            <Typography variant="body2" color="textSecondary">
                                Com estoque zerado, mostramos a etiqueta "Esgotado" sem esconder o item da vitrine.
                            </Typography>
                        </Box>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                        <Typography variant="body2" sx={{ color: exibirEsgotados ? '#9061f9' : '#718096', fontWeight: '500' }}>
                            {exibirEsgotados ? 'Exibindo' : 'Ocultando'}
                        </Typography>
                        <Switch
                            checked={exibirEsgotados}
                            onChange={this.handleToggleChange('exibirEsgotados')}
                            sx={purpleSwitchSx}
                        />
                    </Box>
                </Paper>
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        alignItems: 'flex-end',
                        mt: 4,
                        pt: 2,
                        borderTop: '1px solid #eee'
                    }}
                >


                    <Button

                        variant="contained"
                        startIcon={<SaveOutlinedIcon />}
                        onClick={() => {
                            fetch(`${process.env.REACT_APP_API_URL}/settings/pedidos`, {
                                method: 'POST',
                                credentials: 'include',
                                headers: {
                                    'Content-Type': 'application/json',
                                },
                                body: JSON.stringify(this.state),
                            })
                                .then(response => {
                                    if (response.ok) {
                                        toast.success('Configurações atualizadas com sucesso!');
                                    } else {
                                        toast.error('Erro ao atualizar as configurações.');
                                    }
                                })
                                .catch(error => {
                                    console.error('Erro ao atualizar as configurações:', error);
                                });
                        }}
                        sx={{
                            textTransform: 'none',
                            borderRadius: '8px',
                            bgcolor: '#6200ee',
                            px: 4,
                            '&:hover': { bgcolor: '#4a00b8' }
                        }}
                    >
                        Salvar
                    </Button>
                </Box>
            </Box>
        );
    }
}

export default SecaoPedidos;